class PopupTrigger extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const defaultOpen = this.getAttribute("data-open")
    const durationTrigger = this.getAttribute("data-duration")
    window.addEventListener("variant-selected", (e) => {
      const stock = e.detail.stock
      if (defaultOpen) return
      if (stock) {
        this.setAttribute("data-enable", "false")
      } else {
        this.setAttribute("data-enable", "true")
      }
    })
    this.runSetup()
  }

  runSetup() {
    this.elements = {
      trigger: this.querySelector("button[type='popup-trigger']"),
    }

    const defaultOpen = this.getAttribute("data-open")
    const durationTrigger = this.getAttribute("data-duration")

    if (!this.elements.trigger) {
      console.error("Popup trigger not found")
      return
    }

    const popupListener = () => {
      const popupId = this.elements.trigger.getAttribute("data-popup-id")
      this.elements.dialog = document
        .getElementById(`dialog-${popupId}`)
        .showModal()
      document.body.classList.add("no-scroll")
    }

    if (defaultOpen === "true" && durationTrigger) {
      setTimeout(popupListener, parseInt(durationTrigger))
    } else if (defaultOpen === "true") {
      popupListener()
    }

    this.elements.trigger.addEventListener("click", popupListener)
  }
}

class PopupForm extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.elements = {
      form: this.querySelector("form"),
      submit: this.querySelector('button[type="submit"]'),
    }

    if (!this.elements.form) {
      console.error("Popup form not found")
      return
    }

    if (!this.elements.submit) {
      console.error("Popup form submit button not found")
      return
    }

    const formListener = async (e) => {
      this.classList.add("is-loading")
      e.preventDefault()
      const formData = new FormData(this.elements.form)
      const data = Object.fromEntries(formData.entries())
      const response = await fetch(
        "https://partner-quiz.hello-19e.workers.dev/products/waitlist",
        {
          method: "POST",
          body: JSON.stringify(data),
        }
      )
        .then((e) => {
          this.classList.add("is-submitted")
          this.classList.remove("is-loading")
        })
        .catch((e) => {
          console.error(e)
          this.classList.add("is-error")
          this.classList.remove("is-loading")
        })
    }

    this.elements.form.addEventListener("submit", formListener)
  }

  disconnectedCallback() {
    this.elements.form.removeEventListener("submit", formListener)
  }
}

customElements.define("popup-form", PopupForm)
customElements.define("popup-trigger", PopupTrigger)
